

export function isSameDay(d1, d2) {
  return d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();
}

export function circuit_breaker(func) {
  try {
    func();
  } catch {
    // Do nothing
  }
}

export function is_filled_in(text: string) {
  try {
    if (text === '') {
      return false;
    }
    if (!text) {
      return false;
    }
    if (typeof text === 'undefined') {
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

export function isToday(someDate) {
  const today = new Date()
  return someDate.getDate() == today.getDate() &&
    someDate.getMonth() == today.getMonth() &&
    someDate.getFullYear() == today.getFullYear()
}
